/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Measure_Unit_Asin_PerInputs */

const en_measure_unit_asin_per = /** @type {(inputs: Measure_Unit_Asin_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per asin`)
};

const zh_hans1_measure_unit_asin_per = /** @type {(inputs: Measure_Unit_Asin_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个 ASIN`)
};

const pt_br2_measure_unit_asin_per = /** @type {(inputs: Measure_Unit_Asin_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por ASIN`)
};

const es_measure_unit_asin_per = /** @type {(inputs: Measure_Unit_Asin_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por ASIN`)
};

const fr_measure_unit_asin_per = /** @type {(inputs: Measure_Unit_Asin_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`par asin`)
};

const de_measure_unit_asin_per = /** @type {(inputs: Measure_Unit_Asin_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pro ASIN`)
};

const ru_measure_unit_asin_per = /** @type {(inputs: Measure_Unit_Asin_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`за ASIN`)
};

const it_measure_unit_asin_per = /** @type {(inputs: Measure_Unit_Asin_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per ASIN`)
};

/**
* | output |
* | --- |
* | "per asin" |
*
* @param {Measure_Unit_Asin_PerInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_unit_asin_per = /** @type {((inputs?: Measure_Unit_Asin_PerInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Unit_Asin_PerInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_unit_asin_per(inputs)
	if (locale === "pt-BR") return pt_br2_measure_unit_asin_per(inputs)
	if (locale === "es") return es_measure_unit_asin_per(inputs)
	if (locale === "fr") return fr_measure_unit_asin_per(inputs)
	if (locale === "de") return de_measure_unit_asin_per(inputs)
	if (locale === "ru") return ru_measure_unit_asin_per(inputs)
	if (locale === "it") return it_measure_unit_asin_per(inputs)
	return en_measure_unit_asin_per(inputs)
});